import * as moment from 'moment';
import { Moment } from 'moment';
import { Attachment, IAttachment } from '../../../components/attachment-upload-btn/attachment';

export interface IVisaPermission {
  _id?: string;
  attachment?: IAttachment[];
  date_of_expiry?: Moment;
  date_of_issue?: Moment;
  number?: number;
  visa?: string;
}

export class VisaPermission implements IVisaPermission {
  _id?: string;
  attachment: Attachment[];
  date_of_expiry: Moment;
  date_of_issue: Moment;
  number: number;
  visa: string;

  constructor( visaPermission: IVisaPermission = {} ) {
    this._id = visaPermission._id;
    this.attachment = (visaPermission.attachment || []).map(( item ) => new Attachment(item));
    this.date_of_expiry = visaPermission.date_of_expiry ? moment(visaPermission.date_of_expiry) : null;
    this.date_of_issue = visaPermission.date_of_issue ? moment(visaPermission.date_of_issue) : null;
    this.number = visaPermission.number;
    this.visa = visaPermission.visa;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/visa-permission.ts